var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9163 10.6667V6.66667H9.58301V4H22.9163V6.66667H17.583V10.6667H14.9163ZM5.58301 28V17.3333H8.24967V18.6667H12.2497V14.6667H10.9163V12H21.583V14.6667H20.2497V18.6667H24.2497V17.3333H26.9163V28H24.2497V26.6667H8.24967V28H5.58301ZM8.24967 24H24.2497V21.3333H17.583V14.6667H14.9163V21.3333H8.24967V24Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpl);
export default __webpack_public_path__ + "static/media/gpl.e10c22867d355bd02602735a373084d8.svg";
export { ForwardRef as ReactComponent };